export enum MortgagePageEnum {
  Lender = 'Lender',
  RateAndPeriod = 'RateAndPeriod',
  BorrowedAmountAndTerm = 'BorrowedAmountAndTerm',
  MonthlyPayment = 'MonthlyPayment',
  ProductMatch = 'ProductMatch',
}
